import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Select.scss'


class Simple extends PureComponent {

  static propTypes = {
    options: PropTypes.array.isRequired,
    valueLink: PropTypes.object.isRequired,
    // placeholder: PropTypes.oneOfType([
    //   PropTypes.string,
    //   PropTypes.object
    // ]).isRequired,
  }

  handleChange = (event) => {
    const { valueLink, onChange } = this.props

    const isChanged = event.target.value !== valueLink.value

    if (isChanged) {
      valueLink.set(event.target.value)

      if (typeof onChange === 'function') {
        onChange(event.target.value)
      }
    }
  }

  getRef = (node) => {
    if (!this.node) {
      this.node = node
    }
  }

  render() {
    const { id, options, valueLink, placeholder, className, selectClassName, placeholderClassName } = this.props

    const isDefaultOptionVisible = (
      !valueLink.value
      && !options.some(({ value }) => String(valueLink.value) === String(value))
    )

    const error = valueLink.error

    const rootClassName = cx(s.selectContainer, {
      [s.errored]: Boolean(error),
    })

    // const placeholderClassName = cx(s.placeholder, {
    //   'empty': !Boolean(valueLink.value),
    //   'error': Boolean(error),
    // })

    return (
      <div
        className={cx(rootClassName, className)}
        onChange={this.handleChange}
      >
        {
          Boolean(placeholder && isDefaultOptionVisible && !error) && (
            <div className={cx(s.select, s.defaultOption, placeholderClassName)}>
              {placeholder}
            </div>
          )
        }
        {
          Boolean(error) && (
            <div className={cx(s.select, s.defaultOption, placeholderClassName)}>
              {error}
            </div>
          )
        }
        <select
          className={cx(s.select, selectClassName)}
          ref={this.getRef}
          id={id}
          value={valueLink.value}
          data-value={valueLink.value}
          onChange={this.handleChange}
        >
          <Fragment>
            {
              Boolean(isDefaultOptionVisible) && (
                <option key="defaultOption" className={s.defaultOption} value="" />
              )
            }
            {
              options.map(({ value, title }) => (
                <option key={value} value={value}>{title}</option>
              ))
            }
          </Fragment>
        </select>
      </div>
    )
  }
}


export default Simple
